module.exports = __webpack_public_path__ + "images/psp/FeaturedContentImages/vehicle2.webp";